import React from "react";
import { Card, Image, Spinner, Placeholder } from "react-bootstrap";
import TeamWork from "../../../../../assets/img/teamwork.png";
import Calendar from "../../../../../assets/img/due-date.png";
import Income from "../../../../../assets/img/salary.png";
import Tenants from "../../../../../assets/img/tenats.png";
import { useGetCompanyPropertyDetailsQuery } from "../../../lib/apiSlice/property/propertySlice.tsx";


export default function SelectedPropertyMetrics(PropertyMetrics) {
    const { data, isLoading } = useGetCompanyPropertyDetailsQuery();
    const companyDetails = data?.results[0];
    const MetricData = PropertyMetrics?.metrics

    return (
        <div className="staticCards d-flex justify-content-start mt-5">
            <Card className="w-25 rentDue">
                <Card.Body>
                    <Image src={TeamWork} />
                    <div className="float-left">
                        <span>Total Property Managers</span>
                        <div className="d-flex mt-2">
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <p>{MetricData?.managers_count} Account(s)</p>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>
            {companyDetails?.kra_compliance ?
                <Card className="w-25 defaulters">
                    <Card.Body>
                        <Image src={Calendar} />
                        <div className="float-left">
                            <span className="defaultersText">Total Expected Tax Income</span>
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <p className="">KSH. {MetricData?.expected_tax?.toLocaleString('en-US')}</p>
                            )}
                        </div>
                    </Card.Body>
                </Card>
                :
                <Card className="w-25 defaulters">
                    <Card.Body>
                        <Image src={Calendar} />
                        <div className="float-left">
                            <span className="defaultersText">Total Units</span>
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <p className="defaultersText">{MetricData?.expected_tax} Unit(s)</p>
                            )}
                        </div>
                    </Card.Body>
                </Card>
            }


            <Card className="w-25 income">
                <Card.Body>
                    <Image src={Income} />
                    <div className="float-left">
                        <span>Total Expected Income</span>
                        <div className="d-flex mt-2">
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <p className="">KSH. {MetricData?.expected_rent?.toLocaleString('en-US')}</p>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card className="w-25 occupacy">
                <Card.Body>
                    <Image src={Tenants} />
                    <div className="float-left">
                        <span>Total Tenants</span>
                        <div className="d-flex mt-2">
                            {isLoading ? (
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <p className="">{MetricData?.tenants_count} tenant(s)</p>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}